import { render, staticRenderFns } from "./Suggestai.vue?vue&type=template&id=1cb47876&scoped=true"
import script from "./Suggestai.vue?vue&type=script&lang=js"
export * from "./Suggestai.vue?vue&type=script&lang=js"
import style0 from "./Suggestai.vue?vue&type=style&index=0&id=1cb47876&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1cb47876",
  null
  
)

export default component.exports